import { removeToastrNotification } from 'Favourites/store/actions';

import { connect } from 'react-redux';
import { selectNotifications } from 'Favourites/store/reducers';

const mapStateToProps = (state) => {
    const notifications = selectNotifications(state);
    return { notifications };
};

const mapDispatchToProps = dispatch => {
    return {
        removeToastr: notification => dispatch(removeToastrNotification(notification)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
